import { render, staticRenderFns } from "./spins.vue?vue&type=template&id=2a37bfda&scoped=true&"
import script from "./spins.vue?vue&type=script&lang=js&"
export * from "./spins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37bfda",
  null
  
)

export default component.exports